export const isSekaRdc = (frame, colorIndex = 0) => {
  if (!frame) return false;
  if (frame.name === 'Seka Exaero RDC') return true;
  if (frame.name !== 'Seka Exaero') return false;
  const choice = frame.colors && frame.colors[colorIndex];
  return !!choice && /\bRDC\b/i.test(choice.colorName || choice.color && choice.color.colorName || '');
};

export const sekaBarsForFrame = (bars, frame, colorIndex = 0) => {
  const rdc = isSekaRdc(frame, colorIndex);
  const available = bars.filter(bar => !/^SEKA Gladius(?: ALTA)?$/.test(bar.name || '') || rdc);
  return rdc ? available.sort((a, b) =>
    Number(b.name === 'SEKA Gladius') - Number(a.name === 'SEKA Gladius') ||
    Number(b.name === 'SEKA Gladius ALTA') - Number(a.name === 'SEKA Gladius ALTA')) : available;
};
